const { LISTING_SOURCE } = require('@fiverr-private/variations_display/src');

const DEFAULT_SOURCE = LISTING_SOURCE.MARKETPLACE;
const DEFAULT_LOCALE = 'en-US';

module.exports = {
    DEFAULT_SOURCE,
    DEFAULT_LOCALE,
};
